package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_02_02_Day_1
import com.veldekar.components.logs.Log_2024_02_02_Day_2
import com.veldekar.components.logs.Log_2024_02_02_Day_3
import com.veldekar.components.logs.Log_2024_02_02_Day_4
import com.veldekar.components.logs.Log_2024_02_02_Day_5
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-02-02")
@Composable
public fun Log_2024_02_02(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Fiendish Incidents",
        ogTitle = "Fiendish Incidents",
        date = LocalDate(2_024, 2, 2),
        ogDescription = "The heroes visit a shrine of Doriath, meet Lalia again, and learn of fiendish attacks plagueing the towns near Zedj.",
        ogImage = "ai/2024-02-02.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-41", dateString = "Newgrowth 41")
        Log_2024_02_02_Day_1()
        SessionDayHeader(dayId = "newgrowth-42", dateString = "Newgrowth 42")
        Log_2024_02_02_Day_2()
        SessionDayHeader(dayId = "newgrowth-43", dateString = "Newgrowth 43")
        Log_2024_02_02_Day_3()
        SessionDayHeader(dayId = "newgrowth-44", dateString = "Newgrowth 44")
        Log_2024_02_02_Day_4()
        SessionDayHeader(dayId = "newgrowth-45", dateString = "Newgrowth 45")
        Log_2024_02_02_Day_5()
    }
}
